export default class Cookie {
    banner;
    title;
    message;
    cta;
    template;

    constructor(selector) {
       this.banner = document.querySelector(selector);
        if ( this.banner) {
            if (!this.hasCookie()) {
                this.initBanner();
            } else {
				this.banner.remove();
            }
        }

    }

    initBanner() {
        this.banner.classList.add('show');
        this.acceptBtn = document.getElementById('acceptCookies');
        if (this.acceptBtn) {
            this.acceptBtn.addEventListener('click', () => this.dismiss(true))
        }
        this.declineBtn = document.getElementById('declineCookies');
        if (this.declineBtn) {
            this.declineBtn.addEventListener('click', () => this.dismiss())
        }
    }

    dismiss(accepted = false) {
        this.banner.classList.remove('show');
        if (accepted) {
            this.setCookie('cookiesaccepted', 'true', 30);
            window.location.reload();
        }else{
			this.setCookie('cookiesaccepted', 'false', 30);
		}
        requestTimeout(() => {
            this.banner.remove();
        }, 500)
	}
	
	acceptedCookie() {
        return this.getCookie("cookiesaccepted") === "true";
    }

    hasCookie() {
        return this.getCookie("cookiesaccepted") !== "";
    }

    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }


}